"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var defaultProps = {
  componentName: "threeEqualWidthColumn",
  elementType: "",
  position: [],
  props: {
    //editable part
    style: {
      titleColor: "",
      titleFontSize: "",
      textColor: "",
      textFontSize: ""
    },
    text: {
      // Card one
      cardOneTitle: "Card title",
      cardOneBody: "This is a wider card with supporting text below as a natural\n      lead-in to additional content.",
      // cardOnePrice: "€76.50",
      cardOneSrc: "https://www.dhresource.com/0x0/f2/albu/g8/M01/41/6F/rBVaVFwP7Z2AN91IAAHzBztKv3c118.jpg",
      cardOneAlt: "alt text",

      // Card Two

      cardTwoTitle: "Card title",
      cardTwoBody: "This is a wider card with supporting text below as a natural\n      lead-in to additional content.",
      // cardTwoPrice: "€76.50",
      cardTwoSrc: "https://www.dhresource.com/0x0/f2/albu/g8/M01/41/6F/rBVaVFwP7Z2AN91IAAHzBztKv3c118.jpg",
      cardTwoAlt: "alt text",

      // Card Three

      cardThreeTitle: "Card title",
      cardThreeBody: "This is a wider card with supporting text below as a natural\n      lead-in to additional content.",
      // cardThreePrice: "€76.50",
      cardThreeSrc: "https://www.dhresource.com/0x0/f2/albu/g8/M01/41/6F/rBVaVFwP7Z2AN91IAAHzBztKv3c118.jpg",
      cardThreeAlt: "alt text"
    }
  }
};

exports.default = defaultProps;